// extracted by mini-css-extract-plugin
export var divider = "_jt-0";
export var systemMessage = "_jt-1";
export var systemMessageWrapper = "_jt-2";